import { CommonModule } from '@angular/common';
// import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { NgxPageScrollModule } from 'ngx-page-scroll';

import { SharedModule } from 'shared/shared.module';
import { ProductDetailsComponent } from './product-details.component';
import { ProductDetailsRoutingModule } from './product-details-routing.module';
import { ProductDetailsService } from './product-details.service';
import { ProductPaginationComponent } from './components/product-pagination/product-pagination.component';
import { ProductPanelModule } from '../product-panel/product-panel.module';
import { EcommerceModule } from '../ecommerce/ecommerce.module';

import { BaseSegmentComponent } from './components/base/_base-segment.component';

// segments
import { ItemDetailsComponent } from './components/item-details/item-details.component';
import { DescriptionComponent } from './components/description/description.component';
import { MarketingComponent } from './components/marketing/marketing.component';
import { AttributesComponent } from './components/attributes/attributes.component';
import { PackagingComponent } from './components/packaging/packaging.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { DigitalAssetsComponent } from './components/digital-assets/digital-assets.component';
import { KitsComponent } from './components/kits/kits.component';
import { InterchangeComponent } from './components/interchange/interchange.component';
import { FitmentsComponent } from './components/fitments/fitments.component';
import { HintsTabComponent } from './components/hints-tab/hints-tab.component';
import { SegmentValidationService } from 'shared/validation/segment-validation/segment-validation.service';
import { LogsService } from 'shared/logs/logs.service';
import {NgxPageScrollCoreModule} from 'ngx-page-scroll-core';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ProductDetailsRoutingModule,
        // FormsModule,
        SharedModule,
        ProductPanelModule,
        EcommerceModule,
        NgxPageScrollCoreModule.forRoot({}),
        NgxPageScrollModule,
    ],
    declarations: [
        BaseSegmentComponent,
        ProductDetailsComponent,
        ProductPaginationComponent,
        ItemDetailsComponent,
        DescriptionComponent,
        MarketingComponent,
        AttributesComponent,
        PackagingComponent,
        PricingComponent,
        DigitalAssetsComponent,
        KitsComponent,
        InterchangeComponent,
        FitmentsComponent,
        HintsTabComponent,
    ],
    exports: [],
    providers: [
        ProductDetailsService,
        SegmentValidationService,
        LogsService
    ]
})
export class ProductDetailsModule {}
